import controller from './address.controller';
import templateBase from './templates/address-base.view.html';
import templateAD from './templates/address-adaptative.html';

let AddressComponent = {
    template: changeTemplate,
    controller,
    bindings : {
        shCtrl : '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');
    if(__env.adaptative) {
        return templateAD;
    } else {  
        return templateBase;
    }
}

export default AddressComponent;



/** WEBPACK FOOTER **
 ** ./www/components/address/address.component.js
 **/